import * as React from 'react';

export const PromoArrowIcon = React.memo((props: any) => (
    <svg viewBox="0 0 121.8112 178.39467" version="1.1" className={props.className} aria-hidden="true">
        <defs/>
        <g transform="matrix(1.3333333,0,0,-1.3333333,0,178.39467)">
            <g transform="translate(24.4584,133.7958)">
                <path
                    style={{fill: 'currentColor'}}
                    d="M 0,0 -22.964,-17.31 23.181,-66.49 -24.458,-114.131 0,-133.796 66.9,-66.897 Z"
                />
            </g>
        </g>
    </svg>
));
